import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { ConfirmComponent } from '../dialogs/confirm/confirm.component';

@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) { }

  confirmDialog(): Observable<boolean> {
    return this.dialog
      .open(ConfirmComponent, {        
        width: '400px',
        disableClose: true,
      })
      .afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dialog.service.ts